import React from 'react';
import { Box } from '@mui/material';
import { InvoiceDetailsDialogTitle } from '../shared/Typography/InvoiceDetailsDialogTitle';
import { useTranslation } from 'react-i18next';
import { TableLoadingLayout } from '../layouts/LoadingLayouts/TableLoadingLayout';
import { ErrorTypography } from '../styled/ErrorTypography';
import { GeneralTable } from '../shared/Table/GeneralTable';
import {
    LiveOrderDetailsData,
    LiveOrderDetailsHead,
} from '../../models/LiveOrderProductProps';
import { LiveOrderProductsTableRow } from './LiveOrderProductsTableRow';
import { LIVE_ORDER_PRODUCTS_HEAD_CELLS } from '../../utils/constans/tableHeads/liveOrderProductsHead';

const LiveOrderProducts: React.FC<{
    products: LiveOrderDetailsData[];
    isLoading: boolean;
    isError: boolean;
}> = (props) => {
    const { products, isError, isLoading } = props;
    const { t } = useTranslation('liveOrders', {
        keyPrefix: 'LIVE_ORDER_DETAILS',
    });

    const tableHeadSettings = {
        translateNs: 'liveOrders',
        translatePrefix: 'LIVE_ORDER_DETAILS.TABLE_HEAD',
        selectable: false,
        headContent: LIVE_ORDER_PRODUCTS_HEAD_CELLS,
    };

    const filterTerm = (search) => {
        return products.filter((elem) => {
            return (
                elem.description.toLowerCase().includes(search.toLowerCase()) ||
                elem.itemCode.toLowerCase().includes(search.toLowerCase())
            );
        });
    };

    const tableToolbarSettings = {
        translateNs: 'liveOrders',
        translatePrefix: 'LIVE_ORDER_DETAILS.TABLE_TOOLBAR',
    };

    const setTable = () => {
        switch (true) {
            case isLoading:
                return <TableLoadingLayout />;
            case isError:
                return (
                    <ErrorTypography errorCode={'LIVE_ORDER_DETAILS_ERROR'} />
                );
            case !isLoading && products.length > 0:
                return (
                    <GeneralTable<LiveOrderDetailsData, LiveOrderDetailsHead>
                        fullList={products}
                        rowComponent={LiveOrderProductsTableRow}
                        filterTerm={filterTerm}
                        defaultOrderBy={'description'}
                        selectHandleId={'description'}
                        tableHeadSettings={tableHeadSettings}
                        tableToolbarSettings={tableToolbarSettings}
                        // forceRefresh={forceRefresh}
                        isLoading={isLoading}
                    />
                );
            default:
                return (
                    <ErrorTypography errorCode={'LIVE_ORDER_DETAILS_ERROR'} />
                );
        }
    };

    return (
        <Box sx={{ paddingTop: '20px' }}>
            <InvoiceDetailsDialogTitle>
                {t('PRODUCTS_TITLE')}
            </InvoiceDetailsDialogTitle>
            {setTable()}
        </Box>
    );
};

export default LiveOrderProducts;
